// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_i0RVA","text":"text_P9wsm"};